export default function incrementVersionNumber(document) {
  return {
    ...document,
    versionNumber: (document.versionNumber || 0) + 1
  };
}
